import "../../challenges/Challenges.css"
import React, { useState,useEffect } from "react";
import "../../myProjects/Myprojects.css"
import { FileUploader } from 'react-drag-drop-files';
import api from "views/auth/Api";
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FILES_URL } from '../../../../configs/AppConfig';
import Loader from "components/loader";



const fileTypes = ["JPG", "PNG", "WEBP","JPEG"];

const TrainingDetailsEdit = () => {
  const [img, setImg] = useState(null);
  const [cover, setCover] = useState(null);
  const [cardLoading, setCardLoading] = useState(false);
  const [coverLoading, setCoverLoading] = useState(false);

  const [formInputs , setFormInputs] = useState({
          title:"",
          overview:"",
        });
  const navigate = useNavigate();
  const { id } = useParams();

  const successSaved = () => {
             message.success('Your Trainging Edit Completely');
            };
  const successPhoto = () => {
           message.success('Your Image uploaded successfully');
          };

const isFormValid = formInputs.title.trim() !== '' && formInputs.overview.trim() !== ''  && img !== null;
  
useEffect(() => {
     api.get(`${API_BASE_URL}training/${id}`)
      .then((response) => {  
        if (!response.data) {
          navigate(`/auth/not-found/`);
        }
        setFormInputs({
          title: response.data?.name,
          overview: response.data?.overview,
    });
    setImg(response.data?.img);
    setCover(response.data?.cover);
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [navigate,id]);

    const handleAddRes = (event) => {
    event.preventDefault();
    successSaved()
      EditOne();
    }

    const EditOne = async () => {  
       await api.patch(`${API_BASE_URL}training/${id}`,{
          name: formInputs.title,
          overview: formInputs.overview,
          img: img? img.id : null,
          cover: cover? cover.id : null,
          })
        .then(function (response) {
        navigate(`/admin/training/voxel/${id}`);
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });   
          }

    const handleImgChange = async (img) => {
      setCardLoading(true);
          const formData = new FormData();
          formData.append('img', img);
          console.log('Uploaded file:', img);
           await api.post(`${API_BASE_URL}attachment`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                              setCardLoading(false);
                                  successPhoto();
                                  setImg(response.data);
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });
        };

      const handleCoverChange = async (cover) => {
        setCoverLoading(true);
        const formData = new FormData();
          formData.append('img', cover);
          console.log('Uploaded file:', cover);
           await api.post(`${API_BASE_URL}attachment`,formData, {
                      headers: {
            'Content-Type': 'multipart/form-data',
          },
                    })
                            .then(function (response) {
                                setCoverLoading(false);
                                  successPhoto();
                                    setCover(response.data);
                            }).catch(error => {
                              console.log("handlesubmit error for blog get ", error)
                            });
        };


  return (
    <div className="h-fit w-full pt-10"> 
    <h2 className="addLibrary-h2"> Edit Training</h2> 
   <form className="addChallenge mb-[100px]"> 
      <div className="addChallengeFlex mt-6">
         <div className="addChallengeLR">
    <div className="addCHInpts">
            <label for="title">Training Title</label>
            <input type="text" className="inputWidth" id="title" value={formInputs.title} placeholder="Enter Title" 
            onChange={(e) =>setFormInputs({...formInputs, title: e.target.value})}/>
          </div>
    <div className="addCHInpts">
        <h4 className="trAttachment"> Card Image </h4>
        <div className="mrAtt">
        <FileUploader handleChange={handleImgChange} name="file" types={fileTypes} />
         <Loader loading={cardLoading} />
           {img && !cardLoading ? <img src={`${FILES_URL}${img.url}`} alt="" style={{ width: '200px', height: '150px', marginTop: '10px',borderRadius: '4px' }}/> : null}
        </div>
        </div>

    </div>
        <div className="addChallengeLR">
    <div className="addCHInpts">
            <label for="overview">Overview</label>
            <textarea type="text" className="inputWidth" id="overview" value={formInputs.overview} placeholder="Enter Overview"
             onChange={(e) =>setFormInputs({...formInputs, overview: e.target.value})}/>
           </div>
               <h4 className="trAttachment"> Cover Image </h4>
                <div className="mrAtt">
                <FileUploader handleChange={handleCoverChange} name="file" types={fileTypes} />
                <Loader loading={coverLoading} />
             {cover && !coverLoading ? <img src={`${FILES_URL}${cover.url}`} alt="" style={{ width: '200px', height: '150px', marginTop: '10px' }}/> : null}
                </div>
 
          </div>
</div>

        <div className="flex justify-center gap-x-4 mt-[25px]">
      <button onClick={handleAddRes} disabled={!isFormValid} className="add-plate w-[100px]">Save</button>
      {/* <button onClick={handleAddRes} disabled={!isFormValid} className="add-plate w-[100px]">Save</button> */}
        </div>
       </form> 
    </div>
  );
};

export default TrainingDetailsEdit;
